export const ConfluenceIcon = () => {
    return (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
            <path
                fill="currentColor"
                d="M2.722 17.244c-.211.335-.437.724-.632 1.034a.63.63 0 0 0 .21.86l4.117 2.526a.63.63 0 0 0 .879-.171l.023-.038c.164-.274.377-.631.609-1.014c1.631-2.687
                3.272-2.359 6.229-.947l4.07 1.928a.63.63 0 0 0 .843-.299l.007-.017l1.959-4.421a.63.63 0 0 0-.316-.829a449 449 0 0 1-4.116-1.954C11.043 11.21 6.327
                11.39 2.722 17.244M21.278 6.758c.211-.335.437-.724.632-1.034a.63.63 0 0 0-.21-.86l-4.12-2.528a.63.63 0 0 0-.879.171l-.023.038c-.165.274-.377.631-.609
                1.014c-1.631 2.687-3.272 2.359-6.229.947L5.773 2.579a.63.63 0 0 0-.843.299l-.007.017l-1.961 4.426a.63.63 0 0 0 .315.829c.861.404 2.575 1.211 4.117
                1.954c5.563 2.688 10.279 2.508 13.884-3.346"
            />
        </svg>
    );
};
